module.exports = __webpack_public_path__ + "static/media/A1_Sports_DRAGON_BLACK_1.edc3cf97.png";